// extracted by mini-css-extract-plugin
export var dataCell = "_n4-2";
export var dataRow = "_n4-0";
export var headerRow = "_n4-1";